const DESIGN_MARK = "nuage-password-reset-design:1";

function shell(copy: {
  lang: string;
  title: string;
  heading: string;
  lead: string;
  button: string;
  footer: string;
}) {
  return `<!DOCTYPE html>
<html lang="${copy.lang}">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta name="color-scheme" content="light">
<title>${copy.title}</title>
</head>
<body style="margin:0;padding:0;background:#f3f5f8;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f3f5f8;">
<tr><td align="center" style="padding:24px 12px;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="max-width:560px;">
    <tr><td style="padding:0 4px 12px 4px;">
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td align="left" valign="middle"><img src="{{logoUrl}}" alt="Nuage POS" height="32" style="display:block;height:32px;border:0;"></td>
          <td align="right" valign="middle" style="font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6b7280;">
            Powered by <a href="https://nuagepos.com" style="color:#0ea5e9;text-decoration:none;font-weight:bold;">NuagePOS</a>
          </td>
        </tr>
      </table>
    </td></tr>
    <tr><td style="background:#ffffff;border-radius:12px;border-top:4px solid #0ea5e9;padding:24px 24px 8px 24px;font-family:Arial,Helvetica,sans-serif;">
      <div style="font-size:20px;font-weight:bold;color:#111827;">${copy.heading}</div>
      <div style="font-size:14px;color:#6b7280;padding-top:4px;">{{storeName}}</div>
    </td></tr>
    <tr><td style="background:#ffffff;padding:8px 24px 24px 24px;border-radius:0 0 12px 12px;">
      <!-- ${DESIGN_MARK} -->
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="font-family:Arial,Helvetica,sans-serif;">
        <tr><td style="padding:8px 0 16px 0;font-size:15px;line-height:22px;color:#374151;">${copy.lead}</td></tr>
        <tr><td style="padding:0 0 8px 0;">
          <a href="{{resetUrl}}" style="display:inline-block;background:#0ea5e9;color:#ffffff;text-decoration:none;font-weight:bold;font-size:16px;line-height:48px;padding:0 24px;border-radius:8px;">${copy.button}</a>
        </td></tr>
        <tr><td style="padding:16px 0 0 0;font-size:13px;line-height:20px;color:#6b7280;">${copy.footer}</td></tr>
      </table>
    </td></tr>
    <tr><td style="padding:16px 8px;font-family:Arial,Helvetica,sans-serif;font-size:12px;line-height:18px;color:#6b7280;text-align:center;">
      <a href="https://nuagepos.com" style="color:#6b7280;">nuagepos.com</a>
    </td></tr>
  </table>
</td></tr>
</table>
</body>
</html>`;
}

export const PASSWORD_RESET_DESIGN_MARK = DESIGN_MARK;

export const PASSWORD_RESET_TEMPLATES = [
  {
    id: "password_reset",
    name: "password_reset",
    subject: "Reset your password",
    htmlContent: shell({
      lang: "en",
      title: "Reset your password",
      heading: "Reset your password",
      lead: "{{storeName}} asked to reset the password for {{email}}.",
      button: "Reset password",
      footer: "If you did not expect this message, you can ignore it.",
    }),
  },
  {
    id: "password_reset_fr",
    name: "password_reset_fr",
    subject: "Réinitialisez votre mot de passe",
    htmlContent: shell({
      lang: "fr",
      title: "Réinitialisez votre mot de passe",
      heading: "Réinitialisez votre mot de passe",
      lead: "{{storeName}} demande de réinitialiser le mot de passe de {{email}}.",
      button: "Réinitialiser le mot de passe",
      footer: "Si vous n'attendiez pas ce message, vous pouvez l'ignorer.",
    }),
  },
];
